import { render, staticRenderFns } from "./UserItem.vue?vue&type=template&id=095e418a&"
import script from "./UserItem.vue?vue&type=script&lang=js&"
export * from "./UserItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.clcp.cliquedomains.com/web/app/themes/clc-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('095e418a')) {
      api.createRecord('095e418a', component.options)
    } else {
      api.reload('095e418a', component.options)
    }
    module.hot.accept("./UserItem.vue?vue&type=template&id=095e418a&", function () {
      api.rerender('095e418a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/vue/Components/Blocks/UserItem.vue"
export default component.exports